import getTimeTrackingValue from './getTimeTrackingValue';
import getSumOfLogsForParent from './getSumOfLogsForParent';

export default {
  getTimeTrackingValue,
  getSumOfLogsForParent,
};
